import { Component, OnInit, Input } from '@angular/core';
import { Advert } from '@model/entities/advert'

import { DomSanitizer } from '@angular/platform-browser'
import { UrlPrettifierService } from '@service/urlPrettifier/url-prettifier.service'
import { HelperService } from '@service/helper.service';

@Component({
  selector: 'advert-related-items',
  templateUrl: './advert-related-items.component.html',
  styleUrls: ['./advert-related-items.component.scss']
})
export class AdvertRelatedItemsComponent implements OnInit {

  @Input() direction: 'vertical' | 'horizontal'
  @Input() title: string = ''
  @Input() items: Advert[]

  public fxDirection: 'row' | 'column'
  public fxAlignment: string
  public flexValue: string = 'auto'

  constructor(
    private domSanitizer: DomSanitizer,
    private urlPrettifierService: UrlPrettifierService,
    public helperService: HelperService,
  ) { }

  ngOnInit() {
    if (this.direction == "vertical") {
      this.fxDirection = "column"
      this.fxAlignment = "center"
    } else {
      this.fxDirection = "row"
      this.fxAlignment = "space-between"
      this.flexValue = "25"
    }
  }
}